<ng-container *ngIf="userProfile() as user">
  <div class="profile-wrapper">
    <div class="glow green"></div>
    <div class="glow purple"></div>

    <h2>Profile</h2>

    <div class="avatar-section">
      <img [src]="'assets/images/avatars/' + user.avatar" alt="Avatar" class="avatar-img">
    </div>

    <div class="info-section">
      <div class="username">
        <input
          [formControl]="usernameControl"
          class="edit-input"
          [ngClass]="{
            'input-error': usernameControl.invalid && (usernameControl.dirty || usernameControl.touched)
          }"
          (blur)="updateUsername()"
        />
        <img src="../../../assets/images/edit.png" class="edit-icon" alt="Edit" />
      </div>

      <div class="error" *ngIf="usernameControl.errors?.['required']">Username is required</div>
      <div class="error" *ngIf="usernameControl.errors?.['pattern']">Only A-Z, 0-9, _ and . are allowed</div>
      <div class="error" *ngIf="usernameControl.errors?.['taken']">Username is already taken</div>

      <div class="email">{{ user.email }}</div>
    </div>
  </div>
</ng-container>
